import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { useGetFormDataByLink } from "../../../lib/queries/queriesAndMutations";
import { api } from "../../../utils/axios/Config";
import { handleErrorApi } from "../../../utils/utils";
import Loader from "../../shared/Loader";

const QRCode = () => {
  const { id } = useParams();
  const [formInfo, setFormInfo] = useState({});
  const [qrCode, setQrCode] = useState(null);
  const { data: PortData } = useGetFormDataByLink(id);
  const form = PortData?.form;

  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });
  };

  const handleGetQRCode = async () => {
    try {
      const response = await api.post(
        `/generals/generate/qrcode/`,
        { link: `${import.meta.env.VITE_API_URL}/${id}` },
        { responseType: "blob" },
      );
      const base64QR = await convertBlobToBase64(response.data);
      setQrCode(base64QR);
    } catch (error) {
      handleErrorApi(error);
    }
  };

  useEffect(() => {
    handleGetQRCode();
  }, [id]);

  return (
    <div className="w-full h-full min-h-screen flex flex-col items-center justify-center bg-primary-50 p-4 md:p-8">
      <div className="flex flex-col items-center bg-primary-100 p-6 md:p-12 rounded-2xl shadow-lg w-full max-w-xl">
        {form?.name && <p className="text-title-2xl-semibold text-center mb-4 text-white">{form.name}</p>}

        {qrCode ? (
          <div className="min-w-[300px] flex items-center justify-center mb-4">
            <img src={qrCode} alt="QR Code" className="w-full h-full object-contain" />
          </div>
        ) : (
          <div className="text-gray-500">
            <Loader />
          </div>
        )}
        <h1 className="text-title-3xl-semibold text-white mb-6">وندا پرداخت</h1>
      </div>
    </div>
  );
};

export default QRCode;
